import React from "react";
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "@xyflow/react";

function DataFlowEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, style }) {
    const [edgePath, labelX, labelY] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

    const status = data?.status || "default";
    const strokeColor =
        status === "success" ? "#22c55e" :
        status === "error" ? "#ef4444" :
        status === "running" ? "#3b82f6" :
        "#d1d5db";

    const isAnimated = status === "running";

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                style={{
                    ...style,
                    stroke: strokeColor,
                    strokeWidth: status === "default" ? 1.5 : 2,
                }}
                markerEnd="url(#arrow)"
            />
            {isAnimated && (
                <circle r="3" fill="#3b82f6">
                    <animateMotion dur="1.5s" repeatCount="indefinite" path={edgePath} />
                </circle>
            )}
            {data?.itemCount != null && (
                <EdgeLabelRenderer>
                    <div
                        className="absolute text-[10px] bg-white text-gray-500 px-1.5 py-0.5 rounded border border-gray-200 pointer-events-none shadow-sm"
                        style={{ transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)` }}
                    >
                        {data.itemCount} items
                    </div>
                </EdgeLabelRenderer>
            )}
        </>
    );
}

export default React.memo(DataFlowEdge);
